import getStore from '../store/Store';
import { areFeatureFlagsInitialized } from '../actions/initializeFeatureFlags';
import { FeatureName } from '../store/featureDefinitions';

export default function isFeatureEnabled(feature: FeatureName): boolean {
    if (!areFeatureFlagsInitialized() && process.env.NODE_ENV === 'dev') {
        // We should really interrupt boot here, but not until existing race conditions are fixed.
        // Bug 79015 is tracking that issue. Existing race condition bugs are linked to it.
        console.error('Attempted to read ' + feature + ' before feature flags were initialized.');
    }

    return getStore().featureFlags.get(feature.toLowerCase()) || false;
}
